import { Box, makeStyles } from '@material-ui/core';
import { PropagateLoader } from 'react-spinners';

interface ScreenLoaderProps {
  loading: boolean;
}

const ScreenLoader = ({ loading }: ScreenLoaderProps) => {
  const classes = useStyles();

  if (loading) {
    return (
      <Box className={classes.container}>
        <PropagateLoader size={21} color="#ff6600" loading={loading} speedMultiplier={1.618} />
      </Box>
    );
  }

  return null;
};

const useStyles = makeStyles({
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 2000,
    background: 'whitesmoke',
    backdropFilter: 'blur(6px)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default ScreenLoader;
